<style lang="less">
  div{
    box-sizing:border-box;
    -moz-box-sizing:border-box; /* Firefox */
    -webkit-box-sizing:border-box;
  }
  .my-el-dialog .dialog-choose-what,.my-el-dialog .dialog-choose-what.el-dialog--small{width: 1000px;border-radius: 10px;}
  .my-el-dialog .selected-personnel{height: 40px;padding: 10px;border-bottom: 1px #eee solid;}
  .my-el-dialog .el-dialog{border-radius: 6px;position: relative}
  .my-el-dialog .title{height: 40px;line-height: 40px;padding-left: 16px;color:#000000;font-size: 16px;border-bottom: 1px solid #e5e5e5;}
  .my-el-dialog .el-dialog__header{height:57px;padding:20px;border-bottom: 1px solid #e5e5e5;}
  .my-el-dialog .el-dialog__body{padding:0px }
  .my-el-dialog .el-tree{border:none;}
  .my-el-dialog .seach_box{width: 100%;padding: 10px 20px;overflow: hidden;}
  .my-el-dialog .based_display{padding:0px 20px }
  .my-el-dialog .display_no {display: block;}
  .my-el-dialog .display {display: none;}
  .my-el-dialog .checkStatus{padding:16px 20px;}
  .my-el-dialog .charater-wrap{width: 100%;background: #f2f2f2;padding: 5px 15px;}
  .my-el-dialog .charater-wrap a{color: #a499af;display: inline-block;padding: 2px 7px;}
  .my-el-dialog .charater-wrap a:hover{color: #1d90e6;}
  .my-el-dialog .charater-wrap a.active{color: #fff;background: #1d90e6}
  .my-el-dialog .charater-wrap a.active:hover{color: #fff;background: #1d90e6}
  .my-el-dialog .seach_box .seach{width: 245px;float: left}
  .my-el-dialog .seach_box .more{float: right;display: inline-block;margin-top: 10px}
  .my-el-dialog .seach_box .more a{color:#1f2d3d;font-size:14px }
  .my-el-dialog .footer{position: absolute;left:0px;bottom: 0px;width: 100%;text-align: right;padding:0px 20px 20px 20px}
  .my-el-dialog .person_list{height: 500px;overflow: auto}
  .my-el-dialog .person_list li{text-align: center;margin-top: 10px}
  .my-el-dialog .person_list li a{display: inline-block;width: 90px;height: 28px;line-height: 28px;border: 1px solid #797979;border-radius: 4px;font-size: 12px;color: #333;text-decoration: none}
  .my-el-dialog .person_list li a span{display: inline-block;    float: left;
    padding-left: 10px;width: 50px;font-size: 14px;white-space:nowrap; text-overflow:ellipsis; -o-text-overflow:ellipsis; overflow:hidden;}
  .my-el-dialog .person_list li a i{display: inline-block;width: auto}
  .my-el-dialog .person_list li a i:hover{color: #d98326}
  .my-el-dialog .choosePersonType{position:absolute;font-size: 16px;left: 20px;top:20px;}
  .my-el-dialog .choosePersonType a{margin-right: 10px;color:#999;}
  .my-el-dialog .choosePersonType a:hover{color:#333;text-decoration: none}
  .my-el-dialog .choosePersonType a.active{color:#333;}
  .my-el-dialog .el-tree{display: none}
  .my-el-dialog .el-tree.display_no{display:inline-block}
  .my-el-dialog .treeBox{width:159px;height: 580px;overflow: auto;}
  .my-el-dialog .el-pagination{width: 500px;}
  .my-el-dialog .el-pagination .el-pagination__rightwrapper{float: left}
  .my-el-dialog .selected-works-personnel{width: 100%;height: 450px;border: 1px solid #e5e5e5;}
  .my-el-dialog .selected-works-personnel .selected-personnel span{float: right;color:#999;cursor: pointer}
  .my-el-dialog .selected-works-personnel .selected-personnel span:hover{color:#666 }
  .my-el-dialog .selected-works-personnel .selected-personnel span:hover i{color:#666 }
  .my-el-dialog .selected-works-personnel .selected-personnel span i{float: left;color: #999}
  .my-el-dialog .selected-works-list{padding: 2px 10px;height:400px;overflow: auto; }
  .my-el-dialog .selected-works-list li{padding: 14px 0px; line-height: 15px}
  .my-el-dialog .selected-works-list li .tltle{display: inline-block;width:180px;color: #666;white-space:nowrap; text-overflow:ellipsis; -o-text-overflow:ellipsis; overflow:hidden;}
  .my-el-dialog .selected-works-list li .name{display: inline-block; width: 65px;color: #999;white-space:nowrap; text-overflow:ellipsis; -o-text-overflow:ellipsis; overflow:hidden;}
  .my-el-dialog .selected-works-list li .deleteWorks{color: #999;}
  .my-el-dialog .selected-works-list li .deleteWorks:hover{color: #666;}
  .my-el-dialog .el-pagination.selected-works-pagination .el-pagination__rightwrapper{float: none}
  .tableTitle{max-width: 143px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}
  .footer .el-pagination{float: left;margin: 0;padding: 0;}
</style>
<template>
  <el-dialog class="my-el-dialog myChoosePerson" title="选择作品" custom-class="dialog-choose-what" :visible.sync="is_show" :close-on-click-modal="false" style="z-index: 1000">
    <!--筛选条件-->
    <div class="checkStatus" style="overflow:hidden;position: relative">
      <!--全选、返选-->
      <el-radio-group v-model="checkStatus" @change="checkRadioStatus" style="float:left;">
        <el-radio-button :label="item" v-for="(item,index) in checkStatusData" :key="index"></el-radio-button>
      </el-radio-group>
      <!--任课信息筛选条件-->
      <div @click="styleSelect" style="display: inline-block;float:left;margin-left: 10px;z-index: 2100">
        <el-select clearable v-model="tableQuery.filter.courseCode" placeholder="选择学科" @change="courseCodeChange" style="width:180px; ">
          <el-option v-for="(item,index) in courseCodeData" :key="item.seiCode" :label="item.seiName" :value="item.seiCode"></el-option>
        </el-select>
        <el-select clearable v-model="tableQuery.filter.gradationId" placeholder="选择学段" @change="gradationChange" style="width:180px;margin-left: 5px">
          <el-option v-for="(item,index) in gradationData"  :key="item.id" :label="item.gradationName" :value="item.id"></el-option>
        </el-select>
        <el-select clearable v-model="tableQuery.filter.gradeId" placeholder="选择年级" @change="search" style="width:180px;margin-left: 5px">
          <el-option v-for="(item,index) in gradeData" :key="item.id" :label="item.gradeName" :value="item.id"></el-option>
        </el-select>
        <el-button @click="search" style="margin-left: 10px">查询</el-button>
      </div>
    </div>
    <div style="display:flex;width:980px;" >
      <!--列表数据-->
      <div style="display:flex;width:620px;padding-left: 20px">
        <el-table :data="searchArea.tableData.aaData" ref="multipleTable" @select="handleSelectionChange" @select-all="allselect" :height="ht" class="org_table">
          <el-table-column type="selection"></el-table-column>
          <el-table-column v-for="(vv,index) in defaultConfig.columnList" :key="index" :prop="vv.displayKey" :label="vv.caption"></el-table-column>
        </el-table>
      </div>
      <!--已选作品-->
      <div style="display:flex;width:360px;padding-left: 16px;height: 450px;">
        <div class="selected-works-personnel">
          <div class="selected-personnel">已选作品({{personList.length}}) <span @click="clearAll"><i style="margin-top: 3px;" class="el-icon-delete" ></i> 清空全部</span></div>
          <ul class="selected-works-list">
            <li v-for="(pn,index) in personList" :key="index">
              <span class="tltle">{{pn.workTitle}}</span>
              <span class="name">{{pn.creator}}</span>
              <span class="deleteWorks" @click="unChoose(pn,index)"><i class="el-icon-delete"></i> 删除</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer" style="position: relative;margin-top: 16px">
      <el-pagination @current-change="tableQuery.page = $event, search()" :total="searchArea.tableData.iTotalRecords" 
      :page-size="tableQuery.size" layout="->, prev, pager, next" class="selected-works-pagination" 
      style="width: 600px;text-align: center;"></el-pagination>
      <el-button type="primary" @click="configs.confirm(personList),is_show = false">确定(已选{{personList.length}}个)</el-button>
      <el-button @click="is_show = false">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>

  export default {
    data() {
      return {
        activity:{},//活动
        courseCodeData: [],//课程
        gradeData: [],//年级
        gradationData: [],//学段
        is_show: false,
        checkStatus:"全部",
        checkStatusData : ['全部', '未选'],
        nowLeft: {},
        ht:450,
        tableQuery: {
          page: 1,
          size: 10,
          draw: 0,
          filter:{
            keywords: '',
            activityId:"",
            courseCode:'',
            gradeId:'',
            gradationId:'',
          },
        },
        //作品
        searchArea: {
          tableQuery: {
            page: 1,
            size: 10,
            draw: 0,
            filter: {
              keywords: '',
              activityId:""
            },
          },
          //返回数据
          tableData: {
            aaData: [],
            draw: 0,
            iTotalDisplayRecords: 0,
            iTotalRecords: 0,
          },
        },
        //父页面传递数据
        defaultConfig:"",
        personList:[],//组装数据存放
        selectedData:[],//选中的数据
        allSelectedData:[],
        configs: {
        },
      }
    },
    created(){
      Array.prototype.unique1 = function(){
        var res = [this[0]];
        for(var i = 1; i < this.length; i++){
          var repeat = false;
          for(var j = 0; j < res.length; j++){
            if(this[i].id == res[j].id){
              repeat = true;
              break;
            }
          }
          if(!repeat){
            res.push(this[i]);
          }
        }
        return res;
      };//去重
    },
    mounted(){
    },
    methods: {
      //根据活动id查询活动
      getActivity(){
        let vm = this;
        http.get(InterfacePrefix['resource']+"/activities/"+vm.defaultConfig.actId+"/1").then(function(xhr) {
          if(xhr.data.data){
            vm.activity=xhr.data.data;
            vm.getCourse();
          }
        })
      },
      //根据学科码查询课程
      getCourse(){
        let vm = this;
        http.get(InterfacePrefix['platform'] + '/course/KeChengDaiMa/' +vm.activity.courseCode).then(function (xhr) {
          if(xhr.data.data){
            vm.courseCodeData =xhr.data.data;
          }
        });
      },
      //点击课程
      courseCodeChange(){
        let vm=this;
        let obj={courseCodes:vm.tableQuery.filter.courseCode};
        http.get(InterfacePrefix['platform']+"/gradation/list",{params:obj}).then(function(xhr) {
          vm.gradationData=xhr.data.data;
        });
      },
      //点击学段
      gradationChange(){
        let vm=this;
        let obj={
          gradationIds:new Array(vm.tableQuery.filter.gradationId),
          courseCodes:new Array(vm.tableQuery.filter.courseCode)
        };
        http.get(InterfacePrefix['platform']+"/grade/param?gradationIds="+new Array(vm.tableQuery.filter.gradationId)+"&courseCodes="+new Array(vm.tableQuery.filter.courseCode)).then(function(xhr) {
          if(xhr.data.data){
            vm.gradeData=xhr.data.data;
          }
        })
        vm.search();
      },
      //条件查询作品
      search(){
        let vm = this;
        vm.tableQuery.filter.activityId=vm.defaultConfig.actId;
        let obj = $.extend({}, vm.tableQuery, {filter: eduFilterParam(vm.tableQuery.filter),order:eduFilterParam(vm.tableQuery.order)});
        http.get(InterfacePrefix['resource']+"/activityWorks",{params:obj}).then(function(xhr) {
          _.each(xhr.data.data.aaData, function(vv) {
            vv.querySelected = false
          });
          vm.searchArea.tableData = xhr.data.data;
          vm.allSelectedData=xhr.data.data.aaData;
          vm.$nextTick(function () {
            for(let i=0;i<vm.personList.length;i++){//回显
              for (let j=0;j<vm.searchArea.tableData.aaData.length;j++){
                if(vm.personList[i].id==vm.searchArea.tableData.aaData[j].id){
                  vm.searchArea.tableData.aaData[j].querySelected = true;
                  vm.$refs.multipleTable.toggleRowSelection(vm.searchArea.tableData.aaData[j],true);
                }
              }
            }
          })
        })
      },
      //勾选作品
      handleSelectionChange(e,v,s){
        let vm = this;
        let checked=e==true?e:!v.querySelected;
        if(s){
          s==1?checked=true:checked=false;
        }
        if(checked) {//是否勾选
          for (let j = 0; j < vm.searchArea.tableData.aaData.length; j++) {
            if (v.id == vm.searchArea.tableData.aaData[j].id) {
              vm.searchArea.tableData.aaData[j].querySelected = true;
              vm.$nextTick(function () {
                vm.$refs.multipleTable.toggleRowSelection(vm.searchArea.tableData.aaData[j], true);
              })
            }
          }
        }
        let list = _.filter(vm.searchArea.tableData.aaData, function(vv) {
          return vv.querySelected;
        });
        if(checked){//是否勾选
          let b=[];
          if (list.length!=0){
            let aa=list.length;
            for(var j=0;j<aa;j++){//合并数据
              vm.selectedData.push(list[j]);
            }
          }
          b=vm.selectedData;
          if(vm.selectedData.length>1){
            vm.selectedData=b.unique1();
          }else {
            vm.selectedData=b;
          }
        }else {
          for (let j=0;j<vm.searchArea.tableData.aaData.length;j++){
            if(v.id==vm.searchArea.tableData.aaData[j].id){
              vm.searchArea.tableData.aaData[j].querySelected = false;
              vm.$nextTick(function () {
                vm.$refs.multipleTable.toggleRowSelection(vm.searchArea.tableData.aaData[j], false);
              })
            }
          }
          let s=vm.selectedData.length;
          for (var h=0;h<s;h++){//删除中间缓存数据
            if(vm.selectedData[h].id==v.id){
              vm.selectedData.splice(h,1);
              s=s-1;
              h=h-1;
            }
          }
        }
        if(vm.selectedData.length>1){
          vm.personList=vm.selectedData.unique1();
        }else {
          vm.personList=vm.selectedData;
        }
      },
      //全选作品
      allselect(val){
        let vm=this;
        let el=true;
        if(val.length>0){
          _.each(vm.searchArea.tableData.aaData, function(vv) {
            vv.querySelected = true
            vm.handleSelectionChange(el,vv,1);
          });
        }else {
          _.each(vm.searchArea.tableData.aaData, function(vv) {
            vv.querySelected = false;
            vm.handleSelectionChange(el,vv,2);
          });
        }
      },
      //清空选中
      clearAll(){
        let vm=this;
        vm.selectedData=[];
        vm.personList=[];
        vm.search();
      },

      unChoose(pn,index){
        let vm = this;
        let ii=vm.personList[index];
        var n=vm.personList.length;
        for (let j=0;j<vm.searchArea.tableData.aaData.length;j++){
          if(ii.id==vm.searchArea.tableData.aaData[j].id){
            vm.searchArea.tableData.aaData[j].querySelected = false;
            vm.$nextTick(function () {
              vm.$refs.multipleTable.toggleRowSelection(vm.searchArea.tableData.aaData[j], false);
            })
          }
        }
        for (var j=0;j<n;j++){//删除缓存结果数据
          if(vm.personList[j].id==ii.id){
            vm.personList.splice(j,1);
            n=n-1;
          }
        }
        let d=vm.selectedData.length;
        for (var g=0;g<d;g++){//删除中间缓存数据
          if(vm.selectedData[g].id==pn.id){
            vm.selectedData.splice(g,1);
            d=d-1;
          }
        }
      },


      styleSelect(){
        $(".my-el-dialog").css("z-index","1900")
        $(".v-modal").css("z-index","1800")
      },

      checkRadioStatus(e){
        let vm=this;
        var noselectdata=[];
        if(e=="全部"){
          vm.searchArea.tableData.aaData = vm.allSelectedData;
          _.forEach(vm.searchArea.tableData.aaData,function (v,key) {
            if(v.querySelected){
              vm.$nextTick(function () {
                vm.$refs.multipleTable.toggleRowSelection(vm.searchArea.tableData.aaData[key], true);
              })
            }
          })
        }else {
          _.forEach(vm.searchArea.tableData.aaData,function (v) {
            if(!v.querySelected) noselectdata.push(v);
          });
          vm.searchArea.tableData.aaData=noselectdata;
        }
      }
    },
    computed: {
    },
    watch: {
      nowLeft(val){
        let vm=this;
        vm.defaultConfig=val;
        vm.search();
        vm.getActivity();
      },
      configs(val){
        let vm=this;
        vm.personList=[];
        _.each(val.seletedData, function(vv) {
          vv.querySelected = true;
        })
        vm.personList=val.seletedData;
        vm.selectedData=val.seletedData;
        this.nowLeft = val;
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/commonplugin/choose/chooseWorks.vue